import { useRef, useEffect } from "react";
import styles from "./FormInput.module.css";

export default function FormInput({label, type, required, pattern, errorMsg, setFormValidity}) {

    const inputRef = useRef();
    const id = label.replaceAll(" ","_");

    useEffect(() => {
        setFormValidity(formValidity => {
            return {...formValidity, [id]:false}
        })
    },[setFormValidity, id])
    
    const handleValidation = function() {
        let valid = true;
        const value = inputRef.current.value;

        if(required && value === ""){
            inputRef.current.setCustomValidity("This field is required");
            inputRef.current.reportValidity();
            valid = false;
        }
        else if(!pattern.test(value) && value !== ""){
            inputRef.current.setCustomValidity(errorMsg);
            inputRef.current.reportValidity();
            valid = false;
        }
        else{
            inputRef.current.setCustomValidity("");
        }

        setFormValidity(formValidity => {
            return {...formValidity, [id]:valid}
        })
    }


    return (
        <div className={styles.formInput}> 
            <label htmlFor={id}>{required && <span>*</span>} {label}</label>
            <input 
            name={label}
            id={id}
            ref={inputRef} 
            type={type} 
            onChange={handleValidation}
            onBlur={handleValidation}
            />
        </div>
    );
} 